import BaseValidator from "./BaseValidator";

export default class NumberValidator extends BaseValidator {
    _getDefaultOptions() {
        return {
            min: null,
            max: null,
            numberTypesOnly: false
        };
    }

    /**
     *
     * @param value
     * @param t - translation function (optional)
     * @return {Array}
     */
    validate(value, t = null) {
        let errors = [];
        let valueAsNumber = Number(value);

        // empty array is converted to 0
        if (isNaN(valueAsNumber) || Array.isArray(value)) {
            let errorText = t ? t("validation.number.invalid", { value }) : null;
            errorText = errorText || `${value} is not a valid number`;
            if (errorText) {
                errors.push(errorText);
            }
        } else {
            if (this._options.numberTypesOnly && typeof value !== "number") {
                let errorText = t ? t("validation.number.type") : null;
                errorText = errorText || "must be explicitly of type number";
                if (errorText) {
                    errors.push(errorText);
                }
            }

            if (this._options.min !== null && valueAsNumber < this._options.min) {
                let errorText = t ? t("validation.number.min", { min: this._options.min }) : null;
                errorText = errorText || `Please enter a number that is at least ${this._options.min}`;
                if (errorText) {
                    errors.push(errorText);
                }
            }

            if (this._options.max !== null && valueAsNumber > this._options.max) {
                let errorText = t ? t("validation.number.max", { max: this._options.max }) : null;
                errorText = errorText || `Please enter a number that is no more than ${this._options.max}`;
                if (errorText) {
                    errors.push(errorText);
                }
            }
        }

        return errors;
    }
}
